import { configureStore } from '@reduxjs/toolkit'
import userReducer from '../src/components/slices/userSlice'
import loadingReducer from './components/slices/loadingSlice'

export default configureStore({
  reducer: {
    user: userReducer,
    loading: loadingReducer,
  }
})